import React, { Component } from 'react';
import './style.css';

class TeacherBookingButton extends Component {
  render() {
    const {
      isAuthenticated,
      selectedTimeSlot: { startDateTime, endDateTime }
    } = this.props;
    return (
      <div className="TeacherBookingButton card text-center">
        <p className="my-2">{`Date: ${startDateTime.format(
          'dddd, MMMM Do'
        )} at ${startDateTime.format('h:mmA')} - ${endDateTime.format('h:mmA')}`}
        </p>
        <button
          type="button"
          className="btn btn-primary btn-cursor btn-lg w-100 p-3"
          onClick={this.props.onClick}
          disabled={this.props.disabled}
          data-qa-id="confirm-lesson-button"
        >
          {isAuthenticated ? 'Confirm Lesson' : 'Book Lesson For Free'}
        </button>
      </div>
    );
  }
}

export default TeacherBookingButton;



// WEBPACK FOOTER //
// ./src/components/TeacherBookingButton/index.js